// services/index.ts
// Consolidates frontend service exports. Types come from the 0.99 client.

import { xeroStatus } from '../../client/sdk.gen'
import { sdkData } from './sdkCall'

export { ApiError } from './sdkCall'
export { client } from '../../client/client.gen'
export type * from '../../client/types.gen'
export * from './ApiWrappers'
export * from './ChartDataService'
export type AIPromptConfigPublic = import('../../client/types.gen').AiPromptConfigPublic
export type Partner_RuleCreate = import('../../client/types.gen').PartnerRuleCreate
export type Partner_RuleUpdate = import('../../client/types.gen').PartnerRuleUpdate
export type Partner_RulePublic = import('../../client/types.gen').PartnerRulePublic
export type Referral_AllocationReallocate =
  import('../../client/types.gen').ReferralAllocationReallocate
export type Role_PermissionCreate = import('../../client/types.gen').RolePermissionCreate
export type Role_PermissionPublic = import('../../client/types.gen').RolePermissionPublic
export type Role_AllocationCreate = import('../../client/types.gen').RoleAllocationCreate
export type Role_AllocationPublic = import('../../client/types.gen').RoleAllocationPublic
export type User_PartnerCreate = import('../../client/types.gen').UserPartnerCreate
export type User_PartnerUpdate = import('../../client/types.gen').UserPartnerUpdate
export type User_PartnerPublic = import('../../client/types.gen').UserPartnerPublic
export type Supplier_RateCreate = import('../../client/types.gen').SupplierRateCreate
export type Supplier_RatePublic = import('../../client/types.gen').SupplierRatePublic
export type Source_RateCreate = import('../../client/types.gen').SourceRateCreate
export type Source_RatePublic = import('../../client/types.gen').SourceRatePublic
export type Circs_GradesPublic = import('../../client/types.gen').CircsGradesPublic
export type Source_RatesPublic = import('../../client/types.gen').SourceRatesPublic
export type Supplier_RatesPublic = import('../../client/types.gen').SupplierRatesPublic
export type Veh_GroupsPublic = import('../../client/types.gen').VehGroupsPublic
export type Partner_RulesPublic = import('../../client/types.gen').PartnerRulesPublic

export interface XeroStatus {
  configured: boolean
  tenant_id?: string
  expires_at?: string
  updated_at?: string
  has_refresh_token?: boolean
  error?: string
}

export const XeroApiLegacy = {
  getStatus: async (): Promise<XeroStatus> => {
    return (await sdkData(xeroStatus())) as unknown as XeroStatus
  },

  login: () => {
    window.location.href = '/api/v1/xero/login'
  },
}
